import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import {MIN_USERS_COUNT_FOR_ADD_USERS} from '../../../constants'

const initialState = {
    price: 0,
    currentUsersCountSelected: MIN_USERS_COUNT_FOR_ADD_USERS,
    unlimited: false,
    licenseId: 0,
}

export default handleActions({
    [ActionTypes.PRICE_SET]: (state, {payload: price}) => ({
        ...state,
        price,
    }),
    [ActionTypes.USERS_COUNT_SET]: (state, {payload: currentUsersCountSelected}) => ({
        ...state,
        currentUsersCountSelected,
    }),
    [ActionTypes.UNLIMITED_SET]: (state, {payload: unlimited}) => ({
        ...state,
        unlimited,
    }),
    [ActionTypes.LICENSE_ID_SET]: (state, {payload: licenseId}) => ({
        ...state,
        licenseId,
    }),
}, initialState)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/licenseList/addUsers/reducer.js